var render, staticRenderFns
import script from "./salesPayment.vue?vue&type=script&lang=js&"
export * from "./salesPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccdb09c",
  null
  
)

export default component.exports